import * as React from "react";
import { Modal, Spin, Layout, Input, Button } from "antd";
import { Formik } from "formik";

const { Content } = Layout;

export class AddRedeemCodeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      data: [],
      recordDetails: {},
      isLoading: false, // Fixme this should be true
      closable: true,
    };
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
    });
  }

  hide() {
    this.setState({
      visible: false,
    });
    this.props.onClose();
  }

  validateForm = (values) => {
    const errors = {};

    if (!values.redeem_code) {
      errors.redeem_code = "Redeem code is required";
    }

    return errors;
  };

  handleSubmit = async (values, action) => {
    values.cardId = this.props.data.id;
    this.props.onSubmit(values, this.props.data);

    this.setState({
      visible: false,
    });
  };

  render() {
    const cardName = this.props.data.name;
    return (
      // <StyleBox>
      <Modal
        width="600px"
        closable={this.state.closable}
        open={this.state.visible}
        title={
          <span>
            Add <span style={{ fontWeight: "bold" }}>{cardName}</span> Redeem
            Code
          </span>
        }
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        {this.state.isLoading ? (
          <div style={{ justifyContent: "center" }}>
            <Spin />
          </div>
        ) : (
          <div>
            <Content style={{ background: "#fff", marginLeft: "10px" }}>
              <Formik
                initialValues={{
                  redeem_code: "",
                  serial_number: "",
                }}
                validate={this.validateForm}
                onSubmit={this.handleSubmit}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                  setFieldTouched,
                  isSubmitting,
                }) => {
                  return (
                    <div>
                      <div className="formik-field_wrap">
                        <div className="formik-field-left">
                          Redeem Code
                          <Input
                            id="redeem_code"
                            placeholder="Redeem Code"
                            value={values.redeem_code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.redeem_code && touched.redeem_code ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.redeem_code}
                            </p>
                          ) : null}
                        </div>
                        <div className="formik-field-right">
                          Serial Number
                          <Input
                            id="serial_number"
                            placeholder="Serial Number"
                            value={values.serial_number}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          {errors.serial_number && touched.serial_number ? (
                            <p
                              style={{
                                color: "red",
                                fontSize: "small",
                                margin: "0",
                              }}
                            >
                              {errors.serial_number}
                            </p>
                          ) : null}
                        </div>
                      </div>

                      <Button
                        // type="primary"
                        style={{
                          marginTop: "19px",
                          background: "#5C6AC4",
                          color: "#fff",
                        }}
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                    </div>
                  );
                }}
              </Formik>
            </Content>
          </div>
        )}
      </Modal>
    );
  }
}
